import { render } from "./taskbar_local.vue?vue&type=template&id=a507e6b0"
import script from "./taskbar_local.vue?vue&type=script&lang=js"
export * from "./taskbar_local.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__